<template>
  <div>
    <nx-saved-searches-search-preview-dialog
      :entity="entity"
      :entity-tabs="entityTabs"
      :title="title || $t('message.bag.newSearch')"
      :value="dialogState.searcher.active"
      @input="onSearchSelected"
      @input:dialog="onSearcherClosed"
    />

    <nx-saved-searches-create-dialog
      v-if="dialogState.create.render"
      :value="dialogState.create.active"
      :entity="newSearch.entity"
      :sort="newSearch.sort"
      :filters="newSearch.filters"
      @input="onSearchCreated"
      @input:dialog="onCreateDialogClosed"
    />
  </div>
</template>

<script>
import ManageDialogs, { initDialog } from '@/mixins/manage-dialogs';
import NxSavedSearchesSearchPreviewDialog
  from '@/modules/saved-searches/components/SavedSearchesSearchPreviewDialog.vue';
import NxSavedSearchesCreateDialog from '@/modules/saved-searches/components/SavedSearchesCreateDialog.vue';

export default {
  name: 'nx-saved-searches-wizard',
  components: {
    NxSavedSearchesSearchPreviewDialog,
    NxSavedSearchesCreateDialog,
  },
  mixins: [ManageDialogs],
  props: {
    value: Boolean,
    entity: {
      type: String,
      required: true,
    },
    entityTabs: {
      type: [Boolean, Array],
      default: false,
    },
    title: {
      type: String,
    },
  },
  data() {
    return {
      dialogState: {
        searcher: initDialog(),
        create: initDialog(),
      },
      newSearch: null,
    };
  },
  watch: {
    value: {
      handler(value) {
        this.closeDialog('create');
        if (value) {
          this.openDialog('searcher');
        } else {
          this.closeDialog('searcher');
        }
      },
    },
  },
  methods: {
    dismiss() {
      this.$emit('input:dialog');
    },
    onSearchSelected(newSearch) {
      this.newSearch = newSearch;
      if (newSearch) {
        // If a new search has been selected, open the dialog to name it.
        this.openDialog('create');
      } else {
        // Otherwise, just close the searcher dialog, and dismiss self.
        this.onSearcherClosed();
      }
    },
    onSearcherClosed() {
      this.closeDialog('searcher');
      if (!this.newSearch) {
        // If the searcher modal is closed, and no search has been selected, dismiss self.
        this.dismiss();
      }
    },
    onSearchCreated(newSearch) {
      this.closeDialog('create');
      this.$emit('input', newSearch);
      this.dismiss();
    },
    onCreateDialogClosed() {
      this.closeDialog('create');
      this.dismiss();
    },
  },
};
</script>
